import CommonIcon from "../helpers/icons";

export function UserNotFound({ }) {

    const handleLogin = () => {
        // localStorage.clear();
        const keysToRemove = [
            'AccessTokenTAC',
            'UserInfoTAC',
            'isLoginTAC',
            'iscametoElseScopeTAC',
            'realmNameTAC',
            'redirectURLTAC',
            'userNameTAC',
            'idTokenTAC',
            'isSessionExpiredTAC',
            'isSSOConfigTAC'
        ];

        keysToRemove.forEach(key => localStorage.removeItem(key));
        // window.location.pathname = "/";
        window.location.pathname = "/admin/";
        // window.location.href = process.env.REACT_APP_LOGOUT;
    }

    return (


        <div className="main">
            <div className='submain1' style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className='form ' style={{ height: '400px', width: '600px', marginTop: '-100px', textAlign: 'center' }}>
                    <CommonIcon fileName={'removeuser'} />
                    <h3 style={{ fontSize: '23px' }} className="mt-3">You're not authorized to access this application. </h3>
                    <span>Please contact administrator.</span>
                    <div className='mt-4' >
                        <button onClick={handleLogin} className="btn-fun123">Go to Login</button>
                    </div>
                </div>

            </div>

        </div>)
}